import type { EngineDocument, ScenePage } from "../scene/model";

export function activePage(document: EngineDocument): ScenePage {
  const page = document.pages.find((p) => p.id === document.activePageId);
  if (!page) throw new Error("Активный экран не найден.");
  return page;
}
export function replaceActivePage(
  document: EngineDocument,
  page: ScenePage,
): EngineDocument {
  return {
    ...document,
    pages: document.pages.map((p) =>
      p.id === document.activePageId ? page : p,
    ),
  };
}
export function renumberPages(document: EngineDocument): EngineDocument {
  return {
    ...document,
    pages: document.pages.map((p, i) => ({
      ...p,
      exportName: i ? `screen_${i + 1}` : "index",
    })),
  };
}
export function addPage(
  document: EngineDocument,
  id: string,
  duplicate = false,
): EngineDocument {
  if (document.pages.some((p) => p.id === id))
    throw new Error("Экран с таким ID уже существует.");
  const source = activePage(document),
    page = structuredClone(source);
  page.id = id;
  page.name = duplicate ? source.name + " — копия" : "Экран";
  if (!duplicate) page.nodes = [];
  else {
    const ids = new Map(
      page.nodes.map((n, i) => [n.id, `${id}-object-${i + 1}`]),
    );
    const objects = new Map(
      page.nodes
        .filter((n) => n.interaction.objectId)
        .map((n, i) => [n.interaction.objectId, `${id}-element-${i + 1}`]),
    );
    page.nodes.forEach((n) => {
      n.id = ids.get(n.id)!;
      if (n.layer.groupId) n.layer.groupId = `${id}-${String(n.layer.groupId)}`;
      if (n.interaction.objectId)
        n.interaction.objectId = objects.get(n.interaction.objectId);
      if (n.interaction.targetScreenId === source.id)
        n.interaction.targetScreenId = id;
    });
  }
  return renumberPages({
    ...document,
    activePageId: id,
    pages: [...document.pages, page],
  });
}
export function removePage(
  document: EngineDocument,
  id: string,
): EngineDocument {
  if (document.pages.length <= 1)
    throw new Error("В проекте должен оставаться хотя бы один экран.");
  const index = document.pages.findIndex((p) => p.id === id);
  if (index < 0) return document;
  const pages = document.pages
    .filter((p) => p.id !== id)
    .map((p) => ({
      ...p,
      nodes: p.nodes.map((n) =>
        n.interaction.targetScreenId === id
          ? { ...n, interaction: { ...n.interaction, targetScreenId: "" } }
          : n,
      ),
    }));
  return renumberPages({
    ...document,
    pages,
    activePageId:
      document.activePageId === id
        ? pages[Math.min(index, pages.length - 1)]!.id
        : document.activePageId,
  });
}
